import DocumentsCont from '../../../../components/Common/Documents/DocumentsCont'
import TimelineFeedCont from '../../../../components/Common/TimelineFeed/TimelineFeedCont'
import TaskSystemLinesCont from '../../../../components/Operations/TaskSystem/Lines/TaskSystemLinesCont'
import TaskSystemForm from '../../../../components/Operations/TaskSystem/TaskSystemForm'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import React, { Fragment } from 'react'
import { Breadcrumb, Card, Col, Popconfirm, Row, Tabs, Tag } from 'antd'
import style from '../../../../components/Sales/style.css'
import { strVal } from '../../../../modules/Utils'
import Status from '../../../../elements/Status'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../../elements/CustomSpin'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import CodeIcon from '../../../../elements/CodeIcon'
import History from '../../../../components/Common/History'

AddTaskSystem.propTypes = {}

function AddTaskSystem (props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    submit,
    fetch,
    update,
    formRef,
    task,
    remove,
    removing,
    isUpdatable,
    actions,
    handleActions,
    isConfirmed,
    isNew,
  } = props

  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Task'}
      isNew={isNew}
      isEdit={!isNew}
      isRemovable={['Pending'].includes(task.status)}
    />
  )
  const Operations = ({ task, ...rest }) => {
    const ops = actions
      .filter(a => a.key !== 'update' && a.key !== 'remove')
      .map(a => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure you want to ${a.value} this record?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    if (ops.length > 0 && isConfirmed) {
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to Duplicate?`}
            onConfirm={() => handleActions('duplicate')}
            okText="Yes"
            cancelText="No">
            <a>Duplicate</a>
          </Popconfirm>
        </span>,
      )
    }
    return (
      <div {...rest}>
        {ops.length > 0
          ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr])
          : []}
      </div>
    )
  }

  return (
    <CustomSpin spinning={fetching}>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href={'/#/operations/task-system/'}>Task System</Breadcrumb.Item>
            <Breadcrumb.Item>{isNew ? 'New Task' : task.code}</Breadcrumb.Item>
          </Breadcrumb>
          {isNew && <h2 className={style.title}>New Task</h2>}
          {!isNew && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <CodeIcon code={strVal(task, 'code')} title={'Task Code'}/>
                  <Status value={strVal(task, 'status')}/>
                  {!isNew && <Tag style={{ marginLeft: '10px' }}>{strVal(task, 'state')}</Tag>}
                  <Operations
                    style={{ marginTop: '10px' }}
                    task={task}
                    status={strVal(task, 'status')}
                  />
                </h3>
              </Col>
              <RefreshButton onClick={fetch}/>
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="form">
            <TaskSystemForm ref={formRef} {...props} />
            {isUpdatable && <SubmitButton/>}

            {!isNew && (
              <>
                <Row style={{ backgroundColor: '#f7f8fa' }}>
                  <FormSectionTitle title={'TASK ACTIVITY'}/>
                  <TimelineFeedCont owner={task._id}/>
                </Row>
              </>
            )}
          </Tabs.TabPane>

          <Tabs.TabPane disabled={isNew} tab="Action List" key="todo">
            <FormSectionTitle title={'Action List'}/>
            <TaskSystemLinesCont task={task} isUpdatable={isUpdatable}/>
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="Attachments" key="documents">
            <DocumentsCont editable={true} footer={false} category={false} owner={task}/>
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="History" key="history">
            <History owner={task} key={task._rev} isArray={true}/>
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddTaskSystem
